import React, { useState, useEffect } from 'react';
import copyright from "../../assets/images/copyright-icon.png";
import dot from "../../assets/images/dot-icon.png";
import message from "../../assets/images/message-icon.png";
import call from "../../assets/images/call-icon.png";
import line from "../../assets/images/line-icon.png";
import logo from "../../assets/images/logo.png"
import "./styles.css";
import SignComponent from "../../components/Sign/SignComponent";
import ExploreButton from "../../components/Buttons/ExploreButton";
import PrivacyPolicy from "../../components/Privacy/Privacy";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CloseIcon from '../../assets/images/close-icon.png'
import { toast } from 'react-toastify';
import { url } from '../../api/axios_client';
import axios from '../../api/axios_client';
import './HomeContentEditor.css';
import LanguageSwitcher from '../../components/LanguageSwitcher';

export default function Home() {
  const animate = (state, id) => {
    const p = document.getElementById(id);
    const mediaQuery = window.matchMedia('(max-width: 700px)')
    if (!state) {
      if (mediaQuery.matches) {

        p.style.width = "100%";
        p.style.height = "100%";
      }
      else {

        p.style.width = "40%";

        p.style.transition = "width 2s ";
      }
      p.focus()
    }
    else {
      p.style.width = "0em";
    }
  };

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [activeLanguage, setActiveLanguage] = useState(localStorage.getItem("language") || "ar");
  const [isDirty, setIsDirty] = useState(false);
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };
  
  const [content, setContent] = useState({
    org: '',
    definition: {
      pt1: '',
      pt2: ''
    },
    about: '',
    explore: '',
    terms: '',
    privacy: '',
    contact: {
      email: '',
      phone: ''
    },
    copyright: ''
  });

  useEffect(() => {
    let langcheck = i18n.language === "en" || i18n.language === "ar";
    if(langcheck){
      fetchContent(i18n.language);
    }
  }, [i18n.language]);

  const fetchContent = async (lang) => {
    try {
      const response = await axios.get(`${url}/api/admin/home-content/${lang}`);
      if (response.status === 200) {
        const data = await response.data;
        setContent(data);
        setIsDirty(false);
      } else {
        toast.error('Failed to fetch content');
        loadContent(lang);
      }
    } catch (error) {
      console.error('Error fetching content:', error);
      loadContent(lang);
    }
  };

  const loadContent = (lang) => {
    setContent({
      org: t('Home.org', { lng: lang }),
      definition: {
        pt1: t('Home.definition.pt1', { lng: lang }),
        pt2: t('Home.definition.pt2', { lng: lang })
      },
      about: t('Home.about', { lng: lang }),
      explore: t('Home.explore', { lng: lang }),
      terms: '',
      privacy: '',
      contact: {
        email: '',
        phone: ''
      },
      copyright: ''
    });
  };

  // Toggle - close one when opening the other
  const handleTermsClick = () => {
    if (privacyOpen) {
      animate(privacyOpen, "privacy");
      setPrivacyOpen(false);
    }
    setTermsOpen(true);
    animate(termsOpen, "terms");
  };

  const handlePrivacyClick = () => {
    if (termsOpen) {
      animate(termsOpen, "terms");
      setTermsOpen(false);
    }
    setPrivacyOpen(true);
    animate(privacyOpen, "privacy");
  };

  return (
    <>
      <div className="home-container">
        <div className="home-header">
          <div className='home-header-title'>
            <img src={content.logo ?? logo} className='logo' alt='logo'/>
            <h3 style={{ color: "var(--secondary)", padding:"10px" }}>{content.org}</h3>
          </div>
          <div className='header-btns'>
            <LanguageSwitcher />
            <SignComponent classN="modalcontainer-home" className="account-home"/>
          </div>
        </div>

        <div className="home-content">
          <h2 className="home-header-content">
            {content.definition.pt1} -
            <span style={{ color: "var(--primary)" }}>
              {content.definition.pt2}
            </span>{" "}
          </h2>
          <p style={{ color: "var(--secondary)", marginTop: "1.5em" }}>{content.about}</p>

          <ExploreButton text={content.explore.toUpperCase()} />
        </div>

        <div className="footer">
          <div className="footer-copyright">
            <img src={copyright} style={{ width: "1em" }} />
            <span style={{ marginLeft: "4px" }} className="small-spans">
              {content.copyright}
            </span>
          </div>

          <div className="footer-rest">
            {content?.contact?.email && <div className="icons-div">
              <img src={message} className="icons-footer" />
              <span className="small-spans">{content?.contact?.email}</span>
            </div>}

            <img src={dot} className="hide-on-small" style={{ width: "0.7em" }} />

            {content?.contact?.phone && <div className="icons-div">
              <img src={call} className="icons-footer" />
              <span className="small-spans">{content?.contact?.phone}</span>
            </div>}

            <img src={line} className="hide-on-small" style={{ width: "1.4em" }} />

            <span
              className="small-spans hoverclick"
              onClick={handleTermsClick}
            >
              {t('Home.terms')}
            </span>

            <img src={dot} className="hide-on-small" style={{ width: "0.7em" }} />
            
            <span
              className="small-spans hoverclick"
              onClick={handlePrivacyClick}
            >
              {t('Home.privacy')}
            </span>
          </div>
        </div>

        {/* FIXED: Proper height and scrolling */}
        <div className="privacy-container-panel" style={{ width: "0em", transition: "width 2s ease-in" }} id="privacy">
          <div style={privacyOpen ? { display: "flex", flexDirection: "column", height: "100vh" } : { display: "none" }}>
            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              padding: "1em 2em",
              borderBottom: "1px solid #ddd",
              flexShrink: 0,
              backgroundColor: "white"
            }}>
              <h2 style={{ margin: 0, color: "#333" }}>{t('Home.privacy')}</h2>
              <img 
                src={CloseIcon} 
                onClick={() => {
                  animate(privacyOpen, "privacy")
                  setPrivacyOpen(false)
                }} 
                style={{ cursor: "pointer", width: "1.5em" }}
                alt="Close"
              />
            </div>
            <div style={{ 
              flex: 1,
              overflowY: "auto",
              padding: "2em",
              whiteSpace: "pre-wrap",
              backgroundColor: "white",
              color: "#333"
            }}>
              {content.privacy || "No privacy policy content available."}
            </div>
          </div>
        </div>

        {/* FIXED: Proper height and scrolling */}
        <div className="privacy-container-panel" style={{ width: "0em", transition: "width 2s ease-in" }} id="terms">
          <div style={termsOpen ? { display: "flex", flexDirection: "column", height: "100vh" } : { display: "none" }}>
            <div style={{ 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              padding: "1em 2em",
              borderBottom: "1px solid #ddd",
              flexShrink: 0,
              backgroundColor: "white"
            }}>
              <h2 style={{ margin: 0, color: "#333" }}>{t('Home.terms')}</h2>
              <img 
                src={CloseIcon} 
                onClick={() => {
                  animate(termsOpen, "terms")
                  setTermsOpen(false)
                }} 
                style={{ cursor: "pointer", width: "1.5em" }}
                alt="Close"
              />
            </div>
            <div style={{ 
              flex: 1,
              overflowY: "auto",
              padding: "2em",
              whiteSpace: "pre-wrap",
              backgroundColor: "white",
              color: "#333"
            }}>
              {content.terms || "No terms of use content available."}
            </div>
          </div>
        </div>

      </div>
    </>
  );
}